import { DocumentationAnchor } from '../webhook-documentation/webhook-documentation.component';

export class WebhookSubscription {

  public id: string;
  public subscriberId: string;
  public active: boolean;
  public email: string;
  public subscriptionEvents: WebhookSubscriptionEvent[];

  public static fromDto(ws): WebhookSubscription {
    if (!ws) {
      return null;
    }

    const webhookSubscription = new WebhookSubscription();
    webhookSubscription.id = ws.id;
    webhookSubscription.subscriberId = ws.subscriberId;
    webhookSubscription.active = ws.active;
    webhookSubscription.email = ws.email;
    webhookSubscription.subscriptionEvents = ws.subscriptionEvents.map(se => WebhookSubscriptionEvent.fromDto(se));
    return webhookSubscription;
  }
}

export class WebhookSubscriptionEvent {

  public id: string;
  public eventType: EventType;
  public httpVerbCallback: WebhookHttpVerbCallback;
  public urlCallback: string;

  static fromDto(wse): WebhookSubscriptionEvent {
    if (!wse) {
      return null;
    }

    const webhookSubscriptionEvent = new WebhookSubscriptionEvent();
    webhookSubscriptionEvent.id = wse.id;
    webhookSubscriptionEvent.eventType = wse.eventType;
    webhookSubscriptionEvent.httpVerbCallback = wse.httpVerbCallback;
    webhookSubscriptionEvent.urlCallback = wse.urlCallback;
    return webhookSubscriptionEvent;
  }
}

export class DryRunResponse {
  public response: string;

  static fromDto(drr): DryRunResponse {
    if (!drr) {
      return null;
    }

    const dryRunResponse = new DryRunResponse();
    dryRunResponse.response = drr.response;
    return dryRunResponse;
  }
}

export enum EventType {
  CHECKIN = 'CHECKIN',
  CHECKOUT = 'CHECKOUT',
  ETA_UPDATE = 'ETA_UPDATE',
  BOL_UPDATE = 'BOL_UPDATE',
  TRIP_CREATE = 'TRIP_CREATE',
  TRIP_PATCH = 'TRIP_PATCH',
  TRIP_CLOSED = 'TRIP_CLOSED',
  TRIP_UPDATE = 'TRIP_UPDATE',
  TRIP_CANCEL = 'TRIP_CANCEL',
  PGI = 'PGI',
  FAILED_COLLECTION = 'FAILED_COLLECTION',
  REVERSE_CHECKIN = 'REVERSE_CHECKIN'
}

export function allEventTypes(): EventType[] {
  return [
    EventType.BOL_UPDATE,
    EventType.CHECKIN,
    EventType.CHECKOUT,
    EventType.ETA_UPDATE,
    EventType.TRIP_CREATE,
    EventType.TRIP_PATCH,
    EventType.TRIP_UPDATE,
    EventType.TRIP_CANCEL,
    EventType.TRIP_CLOSED,
    EventType.PGI,
    EventType.FAILED_COLLECTION,
    EventType.REVERSE_CHECKIN,
  ];
}

export enum WebhookHttpVerbCallback {
  POST = 'POST',
  PUT = 'PUT'
}

export function allWebhookHttpVerbCallback(): WebhookHttpVerbCallback[] {
  return [WebhookHttpVerbCallback.POST, WebhookHttpVerbCallback.PUT];
}

export function getDocumentationAnchorFor(eventType: EventType): DocumentationAnchor {
  switch (eventType) {
    case EventType.CHECKIN: return DocumentationAnchor.EVENTS_DELIVERY_CHECKIN;
    case EventType.CHECKOUT: return DocumentationAnchor.EVENTS_DELIVERY_CHECKOUT;
    case EventType.ETA_UPDATE: return DocumentationAnchor.EVENTS_DELIVERY_ETA_UPDATE;
    case EventType.BOL_UPDATE: return DocumentationAnchor.EVENTS_DELIVERY_BOL_UPDATE;
    case EventType.TRIP_CREATE: return DocumentationAnchor.EVENTS_DELIVERY_TRIP_CREATE;
    case EventType.TRIP_PATCH: return DocumentationAnchor.EVENTS_DELIVERY_TRIP_PATCH;
    case EventType.TRIP_CLOSED: return DocumentationAnchor.EVENTS_DELIVERY_TRIP_CLOSED;
    case EventType.TRIP_CANCEL: return DocumentationAnchor.EVENTS_DELIVERY_TRIP_CANCEL;
    case EventType.PGI: return DocumentationAnchor.EVENTS_PGI;
    case EventType.FAILED_COLLECTION: return DocumentationAnchor.EVENTS_FAILED_COLLECTION;
    case EventType.REVERSE_CHECKIN: return DocumentationAnchor.EVENTS_REVERSE_CHECKIN;
    default: return DocumentationAnchor.EVENTS_DELIVERY_CHECKIN;
  }
}
